import actionTypes from '../common/actionTypes';
import { SecurityRoles } from '../common/utils';

interface State {
	currentUser: UserDetails;
}
const initialState = {
	currentUser: {
		isAuthenticated: false,
		fullName: '',
		role: [SecurityRoles.Customer],
		userId: '',
		hasBeenDirected: false,
	}
};
export default function authReducer(state: State = initialState, action: any) {
	switch (action.type) {
		case actionTypes.FETCH_USER_AUTH_SUCCESS:
			action.user.isAuthenticated = true;
			return { ...state, currentUser: {...state.currentUser, ...action.user } };
		
		case actionTypes.FETCH_USER_AUTH_FAILURE: 
		case actionTypes.USER_AUTH_LOGOUT:
			return { ...state, currentUser: initialState.currentUser };
		case actionTypes.SET_DIRECT_STATUS_SUCCESS:
			action.currentUser.hasBeenDirected = true;
			return { ...state, currentUser: {...action.currentUser}};
		case actionTypes.SET_CURRENTUSER_HAS_SIGNED_IN: 
			const currentUser = {...state.currentUser, hasSignedIn: action.hasSignedIn};
			return {...state, currentUser};
		default:
			return state;
	}
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/auth/authReducer.ts